<template>
  <header class="Header" >
    <div class="header_container" id="Header">
      <div class="belt"></div>
      <div class="carousel_content">
        <carousel :autoplay="true" :perPage="1" :autoplayTimeout="10000" :loop="true">
          <slide v-for="slide in slidesList" :key="slide.id">
            <img :src="slide.url">
          </slide>
        </carousel>
      </div>
      <div class="header_wrapper" id="header_wrapper">
        <div class="slogan">
          <div class="slogan_wrapper">
            <h1>
              Colegio "CAYROS"
            </h1>
            <p>
              Inicial - Primaria - Secundaria
            </p>
            <strong>
              Ven y estudia con los mejores...
            </strong>
          </div>
        </div>
        <div class="header_text">
          <div class="logo">
            <img src="@/assets/img/logo.png" alt="logo cayros">
          </div>
          <h1 class="title">
            <span>
              Brindamos Formación Integral
            </span>
          </h1>
          <h2>Generando un liderazgo transformacional, que le facilite su proyecto de desarrollo personal.</h2>
          <button class="Button" @click="scrollTo()"> Contáctanos </button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Scrollbar from 'smooth-scrollbar'
import { firestore } from '@/main'
import { Carousel, Slide } from 'vue-carousel'
// @ is an alias to /src
export default {
  name: 'Header',
  components: {
    Carousel,
    Slide
  },
  data: () => ({
    slidesList: []
  }),
  mounted () {
    this.getAllimages()
    setTimeout(() => {
      const header = document.getElementById('Header')
      header.classList.add('trigger')
    }, 300);
  },
  methods: {
    getAllimages() {
      firestore
        .collection('slide')
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            const data = doc.data()
            this.slidesList.push({
              id: doc.id,
              url: data.url,
            })
          })
        })
        .catch(console.error)
    },
    scrollTo () {
      const scrollbar = Scrollbar.init(document.querySelector('#Home'))
      const contact = document.getElementById('Contact')
      scrollbar.scrollTo(0, contact.offsetTop, 2500)
    },
    openModal () {
      this.$emit('openModal', 1)
    },
    getVideoId (url) {
      const code = url.match(/v=([^&#]{5,})/)
      return (typeof code[1] == 'string') ? code[1] : false;
    }
  }
}
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap')
@import '../assets/css/app.sass'
.Header
  position: relative
  background-color: $primary_color
  .header_container
    width: 980px
    height: 800px
    margin: 0 auto
    z-index: 2
    &.trigger
      .belt
        transform: scaleX(0)
        animation: reveal_scale_x .7s .4s backwards
      .header_wrapper
        .header_text
          .title
            span
              top: 0
              opacity: 1
            &:before
              animation: reveal_square .5s .8s forwards
          h2
            opacity: .5
    .belt
      content: ''
      position: absolute
      left: 0
      top: 0
      height: 800px
      width: 100vw
      transform-origin: right
      background-color: $secondary_color
      z-index: 10
      transition: all ease-in-out .7s
    .carousel_content
      position: absolute
      left: 0
      top: 0
      height: 100%
      width: 100%
      .VueCarousel
        height: 100%
        .VueCarousel-wrapper
          height: 100% !important
          .VueCarousel-inner
            height: 100% !important
          .VueCarousel-slide
            height: 100%
            img
              width: 100%
              height: 100%
              object-fit: cover
              opacity: .2
        .VueCarousel-pagination
          display: none
    .header_wrapper
      display: flex
      justify-content: center
      flex-direction: column
      width: 100%
      height: 100%
      position: relative
      .slogan
        width: 100%
        display: flex
        justify-content: center
        margin-top: 4rem
        .slogan_wrapper
          display: flex
          flex-direction: column
          align-items: center
          h1
            font-weight: 800
            color: $accent_color
            font-size: 40px
            font-family: $font
            margin-bottom: 1rem
          p
            color: white
            font-family: 'Roboto', sans-serif
            margin-bottom: 1rem
            font-size: 18px
          strong
            color: white
            font-size: 24px
            font-family: 'Dancing Script', sans-serif
      .header_text
        flex: 1
        padding-left: 70px
        z-index: 5
        margin-top: 7rem
        .logo
          img
            width: 130px
        .title
          margin-top: 40px
          position: relative
          height: 30px
          span
            position: absolute
            left: 0
            top: -30px
            opacity: 0
            transition: all ease-in-out .3s 1s
          &:before
            height: 0
          &:after
            display: none
            content: ''
            position: absolute
            width: 100%
            height: 100%
            background-color: $primary_color
            left: 0
            top: -30px
        h2
          color: white
          opacity: 0
          font-size: 15px
          font-family: $font_text
          line-height: 1.7
          margin-top: 10px
          max-width: 400px
          width: 100%
          transition: all ease-in-out .5s 1.2s
        .Button
          margin-top: 20px
          margin-left: -1px

@media screen and (max-width: 980px)
  .Header
    position: relative
    .header_container
      width: 760px
      height: 600px
      &:before, &:after
        height: 600px
      .belt
        height: 600px
      .header_wrapper
        &:before
          width: 180px
        .header_text
          .logo
            img
              width: 50px
          .title
            margin-top: 40px
          h2
            font-size: 13px
            margin-top: 0
            max-width: 290px
          .Button
            width: 150px
        .slogan
          margin-top: 3rem
          .slogan_wrapper
            h1
              font-size: 30px
              margin-bottom: 1rem
            p
              margin-bottom: 1rem
              font-size: 16px
            strong
              font-size: 22px

@media screen and (max-width: 760px)
  .Header
    position: relative
    .header_image_content
      display: none
    .header_container
      width: 480px
      height: 600px
      &.trigger
        .belt
          transform-origin: top
          transform: scaleY(1)
          animation: reveal_scale_y .7s .3s forwards
      &:after
        width: 100%
      &:before
        width: 100%
        height: 170px
        bottom: 0
        top: inherit
        z-index: 1
      .belt
        height: 700px
      .pattern, .pattern2
        display: none
      .header_wrapper
        flex-direction: column
        justify-content: space-evenly
        align-items: flex-start
        &:before
          width: 100%
          height: 170px
          bottom: 0
          top: inherit
        .header_text
          margin-top: 2rem
          padding-left: 0
          flex: 0
          h2
            max-width: 320px
        .slogan
          margin-top: 0rem
          .slogan_wrapper
            h1
              font-size: 28px
              margin-bottom: 1rem
            p
              margin-bottom: 1rem
              font-size: 16px
            strong
              font-size: 22px

@media screen and (max-width: 560px)
  .Header
    position: relative
    .header_container
      width: 320px
      .header_wrapper
        .header_text
          h2
            width: 100%
            max-width: inherit

@media screen and (max-width: 400px)
  .Header
    position: relative
    .header_container
      width: 100%
      padding:
        left: 40px
        right: 40px
      box-sizing: border-box
      .header_wrapper
        .header_text
          margin-top: 1rem
          .logo
            z-index: 2
            position: relative
          .title
            line-height: 1.4
            height: 50px
            width: 250px
            span
              top: -50px
            &:after
              top: -50px
          h2
            margin-top: 10px
        .slogan
          margin-top: 0rem
          .slogan_wrapper
            h1
              font-size: 24px
              margin-bottom: 1rem
            p
              margin-bottom: 1rem
              font-size: 14px
            strong
              font-size: 20px


</style>